import { CAPABILITIES } from '../capabilities';

type Props = {
  selected: string[];
  onToggle: (id: string) => void;
  onClear: () => void;
};

export default function CapabilitiesPanel({ selected, onToggle, onClear }: Props) {
  return (
    <div className="p-4" data-testid="composer-capabilities">
      <p className="text-xs text-texts leading-relaxed mb-4">
        Add building blocks to your project. Tap to include the ones you need.
      </p>

      <div className="grid grid-cols-2 gap-2.5">
        {CAPABILITIES.map((c) => {
          const on = selected.includes(c.id);
          return (
            <button
              key={c.id}
              type="button"
              data-testid={`composer-capability-${c.id}`}
              onClick={() => onToggle(c.id)}
              aria-pressed={on}
              className={`relative flex flex-col items-center gap-2 rounded-lg border p-3.5 transition-colors ${
                on ? 'border-accent bg-accentSoft' : 'border-border bg-surface hover:border-accentLine'
              }`}
            >
              <span
                className={`absolute top-2 right-2 w-4 h-4 rounded-full border flex items-center justify-center transition-colors ${
                  on ? 'bg-accent border-accent' : 'border-border'
                }`}
              >
                {on && <i className="ri-check-line text-accent-text text-[10px]" />}
              </span>

              <span className="w-9 h-9 rounded-lg bg-bg border border-border flex items-center justify-center">
                <i className={`${c.icon} text-lg ${on ? 'text-accent' : 'text-texts'}`} />
              </span>

              <span className="text-xs font-medium text-textp leading-tight text-center">{c.label}</span>
              <span className="text-[10px] text-texts leading-tight text-center">{c.hint}</span>
            </button>
          );
        })}
      </div>

      <div className="mt-4 flex items-center justify-between text-[11px] text-texts">
        <span data-testid="composer-capability-count">{selected.length} selected</span>
        {selected.length > 0 && (
          <button
            type="button"
            data-testid="composer-capability-clear"
            onClick={onClear}
            className="hover:text-textp transition-colors"
          >
            Clear
          </button>
        )}
      </div>
    </div>
  );
}
